// function for the logic to set modal heights
const _throttle = require('lodash.throttle');

function setModalHeights() {
    const iosVhFixElements = document.querySelectorAll('.ios-vh-fix');
    const viewportHeight = window.innerHeight;

    for (let iosVhFixElement of iosVhFixElements) {
        iosVhFixElement.style.height = viewportHeight + 'px';
        iosVhFixElement.style.minHeight = viewportHeight + 'px';
        iosVhFixElement.style.maxHeight = viewportHeight + 'px';
    }
}

function adjustModalHeight() {
    const isiOS = /iPad|iPhone|iPod/.test(navigator.platform);

    if (isiOS || window.innerWidth <= 768) {
        const navTogglesMobile = document.querySelectorAll('[data-nav-toggle]');

        const setModalHeightThrottled = _throttle(() => {
            setModalHeights(); // Call the function to set modal heights on resize/scroll
        }, 100);

        // Call the function to set modal heights on page load
        setModalHeights();

        // Attach the throttled function to the resize and scroll events
        window.addEventListener('resize', setModalHeightThrottled);
        window.addEventListener('scroll', setModalHeightThrottled);

        for (const navToggleMobile of navTogglesMobile) {
            navToggleMobile.addEventListener('click', setModalHeightThrottled);
        }
    }
}

// Run the main function when the DOM is loaded
window.addEventListener('load', adjustModalHeight);
